import { createFileRoute } from '@tanstack/react-router';
import { Trans } from 'react-i18next';

import { RouteGuard } from '@/components';

export const Route = createFileRoute('/admin/exchange-rates/_auth')({
  component: () => <RouteGuard can="manage" a="ExchangeRate" />,
  beforeLoad: () => ({
    breadcrumb: () => <Trans i18nKey="exchangeRates.title" />,
  }),
});
